import "@/styles/styles.scss";

import Vue from "vue";
import axios from "axios";
import moment from "moment";
import "@/components/global.register";
import "@/plugins/vuetify.radiogroup";
import "./registerServiceWorker";
import { rules } from "@/utilities/validations";
import { AppConfiguration } from "./models/app/app.configuration";
Vue.config.productionTip = false;
const configuration: AppConfiguration = new AppConfiguration();

axios.defaults.headers.common["App"] = "Backend";
axios.defaults.headers.get["Accepts"] = "application/json";
Vue.prototype.$http = axios;
Vue.prototype.$rules = rules;
Vue.prototype.company = process.env.VUE_APP_CONFIGS_NAME;
Vue.prototype.getMenu = (module: string, name: string) =>
  configuration?.getMenu(module, name);

Vue.filter("date", function(value: Date | null) {
  return value
    ? moment(value).format(process.env.VUE_APP_CONFIGS_DATE_FORMAT)
    : "";
});
Vue.filter("datetime", function(value: Date | null) {
  return value
    ? moment(value).format(process.env.VUE_APP_CONFIGS_DATETIME_FORMAT)
    : "";
});

import Init from "@app/init";
Init();
